export default __webpack_public_path__ + "static/media/admin-icon.725d6c9a.svg";